"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuickOrderFormResults = void 0;
var _mui = require("@ori-ui/mui");
var _FormattedMessage = require("./FormattedMessage");
var _QuickOrderFormResultRow = require("./QuickOrderFormResultRow");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('ul')(({
  theme
}) => ({
  background: theme.palette.background.paper,
  border: `2px solid ${theme.palette.grey[100]}`,
  borderRadius: theme.shape.borderRadius,
  boxShadow: _mui.SHADOW_LEVEL2,
  boxSizing: 'border-box',
  left: 0,
  listStyleType: 'none',
  margin: 0,
  maxHeight: 228,
  overflowX: 'hidden',
  overflowY: 'auto',
  padding: theme.spacing(6, 5, 2),
  position: 'absolute',
  top: 0,
  transform: 'translateY(18px)',
  width: 'calc(100% - 151px)' /* width of button + button margin + padding + border */,
  zIndex: 1,
  '&::-webkit-scrollbar': {
    display: 'none'
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    padding: theme.spacing(5, 3, 2)
  }
}));
const EmptyListItem = (0, _mui.styled)('li')(({
  theme
}) => ({
  color: theme.palette.grey[900],
  display: 'flex',
  fontSize: theme.typography.body1.fontSize,
  padding: theme.spacing(2, 0)
}));
const QuickOrderFormResults = ({
  'data-testid': testId,
  getMenuProps,
  getItemProps,
  highlightedIndex,
  inputValue,
  isLoading,
  results
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
  ...getMenuProps(),
  "data-testid": testId,
  children: [isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(EmptyListItem, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
      id: "loading"
    })
  }) : null, !isLoading && !results.length && /*#__PURE__*/(0, _jsxRuntime.jsx)(EmptyListItem, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
      id: "noDataFound"
    })
  }), !isLoading && results.length > 0 && results.map((item, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_QuickOrderFormResultRow.QuickOrderFormResultRow, {
    "data-testid": `${testId}-row-${index}`,
    item: item,
    isHighlighted: highlightedIndex === index,
    inputValue: inputValue,
    ...getItemProps({
      index,
      item: {
        name: String(item.description),
        price: item.price,
        value: Number(item.itemCode)
      }
    })
  }, `${item.description}${index.toString()}`))]
});
exports.QuickOrderFormResults = QuickOrderFormResults;